import { Link } from 'react-router-dom';
import Header from '../../components/Header';  
import Footer from '../../components/Footer'; 
import ServiceNav from '../../components/ServiceNav';
import NotarySpecialization from '../../components/NotarySpecialization';

function NotaryPerson() {

	return( 
	<>  
    
   <Header />  
    <main> 
    <section class="tp-hero-area p-relative">
            <div class="tp-hero-wrapper-slider">
               <div class="swiper-container">
                  
               <div class="swiper-wrapper">
                        <div class="swiper-slide pt-20 pb-150 tp-hero-bg-image" data-bg-color="#20536d">
                            <img class="tp-hero-bg" src="../assets/images/banner-bg.png"/>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    <section class="tp-service-details-area pt-120 pb-120">
            <div class="container">
               <div class="row">
                  <div class="col-lg-4">
                     <div class="tp-service-widget">
                        <div class="tp-service-widget-item mb-40">
                                                      <ServiceNav activePath="/NotaryPerson" />
                        </div> 
                     </div>
                  </div>
                  <div class="col-lg-8">
                     <div class="tp-service-details-wrapper"> 
                        <h3 class="tp-service-details-title">Notary in person (IPEN)</h3>
                        <p>Licenced notary available 24x7 with one phone call away . We come to your doorstep or meet at common place </p>
                        <NotarySpecialization />
                        <div class="tp-service-details-thumb">
                           <img src="../assets/images/notary-person.jpg" alt=""/> 
                        </div> 
                        <div class="tp-service-bg tp-service-details-box-2 tp-service-details-box-4 d-flex mb-40">
                           <div class="tp-service-details-box-content mr-30">
                              <h6>Please contact us for estimation</h6>
                              <Link class="tp-btn-service" to="/ContactUs">
                                Contact Us
                              </Link>
                           </div> 
                        </div>
                          
 
                     </div>
                  </div>
               </div>
            </div>
         </section>
        
    </main>
    <Footer/>

  </> 
  ); 
  } 
  export default NotaryPerson;